import { UntypedFormControl, UntypedFormArray } from '@angular/forms';

export class DescriptionModel {
  shortDescription: UntypedFormControl;
  invoiceDescription: UntypedFormControl;
  longDescription: UntypedFormControl;
  extendedDescription: UntypedFormControl;
  applicationSummary: UntypedFormControl;
  associatedComments: UntypedFormArray;
  marketingDescription: UntypedFormArray;
  fabDescription: UntypedFormArray;
  abbreviatedDescription: UntypedFormControl;
  labelDescription: UntypedFormControl;
  keySearchWords: UntypedFormControl;
  shippingRestrictions: UntypedFormControl;
  slangDescription: UntypedFormControl;
  unspscDescription: UntypedFormControl;
  vmrsDescription: UntypedFormControl;
  capDescription: UntypedFormControl;
  traDescription: UntypedFormControl;
}
